import { BASE_DOMAINS, MAX_AGE_FOR_LOCALE_COOKIE } from '../constants';
import { getDomains } from './domainUtils';

/**
 * 判断请求是否为官网服务 API 请求, 路由格式必须严格控制匹配 /:path/ajax/:namespace/:action
 * 因账户应用存在ajax多种请求路由，现修改为/\/ajax/
 * @param {string} req.path
 */
// export const isAPIRequestAbsolute = (path) => /^\/([\w-]+)\/ajax\/(\w+)\/(\w+)$/.test(path);
export const isAPIRequestAbsolute = (path) => /\/ajax/.test(path);

export const isResourcesRequest = (path) => {
  const strPath = String(path).toLowerCase();
  return (
    strPath.includes('/qccomponent/')
    || strPath.endsWith('/qccomponent')
    || strPath.includes('/saas/')
    || strPath.endsWith('/saas')
  );
};

export { getDomains }; // 后续建议直接从domainUtils引用，不要从这里引用

/**
 * 获取提供给用户访问的原始域名
 * @param  {Object} req 请求 request
 * @param {{withoutPort: boolean}} options 设置。withoutPort不带端口
 * @return {String}     访问域名
 * @author lockewu
 */
export function getRealHostname(req, options = {}) {
  // next.js子应用获取前置请求的host / NextRequest的host获取 / express的host获取方法 / 默认固定host
  let HOST =    req?.headers?.['x-forwarded-host']
    || (typeof req?.headers?.get === 'function' && req.headers.get('host'))
    || (typeof req?.get === 'function' && req.get('Host'));
  if (HOST && options && options.withoutPort) {
    HOST = HOST.replace(/(:\d+)/g, '');
  }
  // return HOST;
  const result = HOST && BASE_DOMAINS.ROOT_HOSTS.some((i) => HOST.endsWith(i));
  return result ? HOST : BASE_DOMAINS.QCMAIN_HOST;
}

// 域名多个时支持切换设定cookie，域名不能写死，封装函数
export const getCookieOpt = (req) => {
  const realHostnameWithoutPort = getRealHostname(req, { withoutPort: true });
  const domainsWithoutPort = getDomains(realHostnameWithoutPort);
  const cookieDomain = `.${domainsWithoutPort.QCLOUD_ROOT_HOST}`;
  return {
    domain: cookieDomain,
    path: '/',
    maxAge: MAX_AGE_FOR_LOCALE_COOKIE,
  };
};
